/**
 * Machine status constants
 */
export const MACHINE_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  ERROR: 'error'
};

/**
 * MachineData class for handling machine objects
 */
export class MachineData {
  static STATUS = MACHINE_STATUS;

  constructor(data) {
    this.machine_id = data.machine_id;
    this.hostname = data.hostname || '';
    this.ip_address = data.ip_address || '';
    this.os_type = data.os_type || '';
    this.os_version = data.os_version || null;
    this.status = data.status || MACHINE_STATUS.OFFLINE;
    this.current_user = data.current_user || null;
    this.agent_version = data.agent_version || null;
    this.last_heartbeat = data.last_heartbeat || null;
    this.capabilities = data.capabilities || [];
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  /**
   * Check if machine is online
   */
  get isOnline() {
    return this.status === MACHINE_STATUS.ONLINE;
  }

  /**
   * Check if machine is offline
   */
  get isOffline() {
    return this.status === MACHINE_STATUS.OFFLINE;
  }

  /**
   * Check if machine has an error
   */
  get hasError() {
    return this.status === MACHINE_STATUS.ERROR;
  }

  /**
   * Get number of available applications
   */
  get appCount() {
    return this.capabilities?.length || 0;
  }

  /**
   * Check if machine has a specific profile capability
   */
  hasProfile(profileId) {
    return this.capabilities?.some(c => c.profile_id === profileId) || false;
  }

  /**
   * Create MachineData from API response
   */
  static fromApiResponse(data) {
    return new MachineData(data);
  }

  /**
   * Create array of MachineData from API response list
   */
  static fromApiResponseList(dataList = []) {
    return dataList.map(MachineData.fromApiResponse);
  }

  /**
   * Sort machines: online first, then alphabetically by hostname
   */
  static sort(machines) {
    return [...machines].sort((a, b) => {
      // Online machines first
      if (a.status === MACHINE_STATUS.ONLINE && b.status !== MACHINE_STATUS.ONLINE) return -1;
      if (a.status !== MACHINE_STATUS.ONLINE && b.status === MACHINE_STATUS.ONLINE) return 1;
      // Then alphabetically by hostname
      return a.hostname.localeCompare(b.hostname);
    });
  }
}

/**
 * MachineCapability for tracking installed applications
 */
export class MachineCapability {
  constructor(data) {
    this.machine_id = data.machine_id;
    this.profile_id = data.profile_id;
    this.executable_path = data.executable_path || '';
    this.detected_version = data.detected_version || null;
    this.validated_at = data.validated_at;
  }

  static fromApiResponse(data) {
    return new MachineCapability(data);
  }

  static fromApiResponseList(dataList = []) {
    return dataList.map(MachineCapability.fromApiResponse);
  }
}







